import{styled as o}from"@lokalise/styled";const t=o.button.withConfig({displayName:"Pressable__Root",componentId:"sc-1gn6gwf-0"})(["cursor:pointer;"]);export{t as Root};
//# sourceMappingURL=styles.js.map
